import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "c-download-bottom-wrap"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont-front icon-right"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return !_ctx.isApp ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "c-download-bottom",
    style: _normalizeStyle($options.styles)
  }, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default", {}, () => [_createElementVNode("button", {
    type: "button",
    class: "c-download-bottom-btn moblink-app",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click'))
  }, [_createTextVNode(_toDisplayString($props.text), 1), _hoisted_2])])])], 4)) : _createCommentVNode("", true);
}